import { Route } from "react-router-dom";
import WorkerAllPlans from "../components/view_plans";
import WorkerPlanPaymentSuccess from "../components/view_plan_sucess";
import WorkerPlanPaymentFailed from "../components/view_plan_failed";

const WorkerAllPlansRoutes = () => (
  <>
    <Route path="/worker-allplans" element={<WorkerAllPlans />} />
    <Route path="/worker-plan-success" element={<WorkerPlanPaymentSuccess />} />
    <Route path="/worker-plan-failed" element={<WorkerPlanPaymentFailed />} />
  </>
);


export default WorkerAllPlansRoutes;